import React from "react";
import { Container } from "react-bootstrap";
import "./JobCareer.css";

const JobCareer = () => {
  return (
    <section className="jobcareer-page">
      <Container>

        <h1 className="jobcareer-heading">
          Careers at Plenary Holidays
        </h1>

        <h2 className="jobcareer-subheading">
          Build the Future of Travel & MICE With Us
        </h2>

        <p>
          For over 16 years, Plenary Holidays has grown steadily—not just in business, but in people. Our journey has been built on trust, discipline, and long-term relationships.
        </p>

        <p>
          We are not just a travel company managing itineraries and events. We are a team that believes in responsibility, integrity, and professional conduct in everything we do.
        </p>

        <p>
          If you are looking to build a meaningful career in travel, hospitality, and MICE, we welcome you to explore opportunities with us.
        </p>

        <h3 className="jobcareer-subheading">Our Work Philosophy</h3>

        <p><strong>People. Professionalism. Purpose.</strong></p>

        <p>
          At Plenary Holidays, we believe that strong moral values are the foundation of sustainable growth. Travel involves handling sensitive information, managing large financial transactions, coordinating complex logistics, and representing clients in important moments.
        </p>

        <p>We expect our team members to carry:</p>

        <ul>
          <li>Integrity in decision-making</li>
          <li>Respect toward clients and colleagues</li>
          <li>Ownership of responsibilities</li>
          <li>A client-first mindset</li>
          <li>Commitment to continuous improvement</li>
        </ul>

        <p>
          As a member of the Global Association of Events & Hospitality Professionals (GAEHP), we maintain structured operational standards and ethical business practices across leisure and corporate travel.
        </p>

        <p>
          We work like a close-knit team, but operate with professional discipline.
        </p>

        <h3 className="jobcareer-subheading">Work Locations</h3>

        <p>We operate across the National Capital Region:</p>

        <p><strong>Corporate Headquarters (Owned Office)</strong></p>
        <p>311, H-4, Vardhman North Ex-Plaza</p>
        <p>Netaji Subhash Place (NSP), Pitampura</p>
        <p>New Delhi – 110034</p>

        <p><strong>Operational Hub</strong></p>
        <p>Sector 62, Noida</p>

        <p>
          Roles may be assigned at either location based on operational requirements.
        </p>

        <h3 className="jobcareer-subheading">Who We Are Looking For</h3>

        <p><strong>Experienced Professionals</strong></p>

        <p>
          We are looking for individuals who can confidently manage:
        </p>

        <ul>
          <li>Corporate & MICE accounts</li>
          <li>International travel coordination</li>
          <li>Group movements and event logistics</li>
          <li>Vendor negotiations and operational execution</li>
          <li>Client relationship management</li>
          <li>Structured documentation and GST-compliant billing</li>
        </ul>

        <p>
          If you are detail-oriented, calm under pressure, and capable of handling high-value corporate clients with maturity and clarity, we would like to connect with you.
        </p>

        <h3 className="jobcareer-subheading">
          Freshers & Aspiring Travel Professionals
        </h3>

        <p>
          We strongly believe in building talent from within. Fresh graduates who are serious about pursuing a career in travel and hospitality are welcome to apply.
        </p>

        <p>We provide:</p>

        <ul>
          <li>Structured training sessions</li>
          <li>Hands-on exposure to Leisure and MICE operations</li>
          <li>Apprenticeship opportunities</li>
          <li>Mentorship from experienced industry professionals</li>
          <li>Guidance toward recognized travel certifications</li>
        </ul>

        <p>
          We do not rush responsibilities. We invest time in developing skills properly.
        </p>

        <h3 className="jobcareer-subheading">
          Employee Support & Work Culture
        </h3>

        <p>
          We understand that a stable and supportive environment allows people to perform at their best.
        </p>

        <p>To ensure comfort and well-being, we provide:</p>

        <ul>
          <li>Cab pickup and drop facilities (as per company policy)</li>
          <li>Meal support during working hours</li>
          <li>A professional, well-maintained office environment</li>
          <li>Collaborative and respectful team culture</li>
          <li>Periodic health and wellness sessions, including guided yoga and awareness programs</li>
        </ul>

        <p>
          We encourage balanced growth—professionally and personally.
        </p>

        <h3 className="jobcareer-subheading">Current Openings</h3>

        <p>We periodically hire for roles such as:</p>

        <ul>
          <li>MICE Operations Manager</li>
          <li>Corporate Sales Executive (B2B)</li>
          <li>Domestic & Inbound Travel Specialist</li>
          <li>International Ticketing & GDS Executive</li>
          <li>Digital Marketing & Content Executive</li>
          <li>Accounts & Billing Executive</li>
        </ul>

        <p>
          Even if a suitable opening is not currently listed, we welcome proactive applications from serious candidates.
        </p>

        <h3 className="jobcareer-subheading">
          Equal Opportunity & Ethical Hiring
        </h3>

        <p>Plenary Holidays is an equal opportunity employer.</p>

        <p>
          We value diversity, merit, and professional capability. Our recruitment process is conducted with transparency and fairness.
        </p>

        <h3 className="jobcareer-subheading">How to Apply</h3>

        <p>
          If your values align with ours and you are ready to grow with a stable and ethically-driven Travel Management Company, we would be glad to hear from you.
        </p>

        <p>Send your updated Resume/CV to:</p>

        <p><strong>📧 mail@plenaryholidays.com</strong></p>

        <p>
          Subject Line: Application for [Job Role] – [Your Name]
        </p>

      </Container>
    </section>
  );
};

export default JobCareer;